<style scoped>
    .main-menu-title-h1 {
        font-size: 3.5rem; 
        font-weight: 400; 
        line-height: 1.2;
    }

    .main-menu-navigation-card-title {
        font-size: 1.75rem;
        font-weight: 400;
        margin: 0px 0px 24px 0px;
        line-height: 1.2;
        word-break: break-word;
    }

    @media only screen and (max-width: 768px) {
        .main-menu-title-h1 {
            font-size: 1.75rem;
        }

        .main-menu-navigation-card-title {
            font-size: 1.25rem;
        }
    }

    .main-menu-navigation-card-text {
        font-size: 1rem;
        word-break: break-word;
        min-height: 64px;
        line-height: 24px;
        font-weight: 300;
        cursor: pointer;
    }

    .main-menu-navigation-card {
        padding: 16px 32px 0px 0px;
        position: relative;
        border-top: 2px solid #000;
    }

    .main-menu-navigation-card:hover:before {
        opacity: 1;
    }

    .main-menu-navigation-card:hover > .catalog-top-nav-router-link > .main-menu-navigation-card-title {
        text-decoration: underline;
    }

    .main-menu-navigation-card:before {
        right: 0;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIwLjk5OCAzSDN2MmgxNnYxNmgxLjk5OFYzeiIgZmlsbD0iIzAwMCIvPjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0zIDE5LjQwOUwxOS4wMTUgMy4zOTRsMS41OSAxLjU5MUw0LjU5MiAyMXoiLz48L3N2Zz4=);
        background-size: cover;
        content: "";
        position: absolute;
        opacity: 0;
        box-sizing: border-box;
        background-position: 0 0;
        z-index: 10000;
        display: inline-block;

        top: 24px;
        width: 26px;
        height: 26px;

        transition: opacity .3s;
    }
</style>


<template>
<span>
    <v-card
          fluid
          elevation="0"
          class="mr-0"
          style=""
        >
        <v-container style="max-width: 1680px; padding-top: 48px; padding-bottom: 96px;" class="container-side-padding" fluid>
            <!-- <v-row> -->
                <h1 class="main-menu-title-h1">Каталог системи</h1>
            <!-- </v-row> -->
        </v-container>
    </v-card>
    <v-card
          fluid
          elevation="0"
          class="mr-0 mb-20"
          style=""
        >
        <v-container style="max-width: 1680px; padding-bottom: 96px; padding-top: 0px;" class="justify-center container-side-padding" fluid>
            <v-row class="pa-0 ma-0">
                <v-col cols="12" :sm="6" :md="4" class="pa-0 pr-sm-4 pb-3 pb-sm-12 pb-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'organizations-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Організації</div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_ORGANIZATIONS_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
                <v-col cols="12" :sm="6" :md="4" class="pa-0 pr-sm-0 pr-md-4 pl-sm-4 pb-3 pb-sm-12 pb-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'information-resources-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Е-ресурси</div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_INFORMATION_RESOURCES_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
                <v-col cols="12" :sm="6" :md="4" class="pa-0 pr-md-0 pr-sm-4 pl-sm-0 pl-md-4 pb-3 pb-sm-12 pb-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'subsystems-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Підсистеми</div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_SUBSYSTEMS_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
                <v-col cols="12" :sm="6" :md="4" class="pa-0 pl-sm-4 pl-md-0 pr-sm-0 pr-md-4 pb-3 pb-sm-12 pb-md-12 pt-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'interfaces-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Інтерфейси е-ресурсів</div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_INTERFACES_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
                <v-col cols="12" :sm="6" :md="4" class="pa-0 pl-sm-0 pr-sm-4 pl-md-4 pr-md-4 pb-3 pb-sm-12 pb-md-12 pt-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'services-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Сервіси</div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_SERVICES_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
                <v-col cols="12" :sm="6" :md="4" class="pa-0 pl-sm-4 pr-sm-0 pl-md-4 pr-md-0 pb-3 pb-sm-12 pb-md-12 pt-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'interactions-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Взаємодії</div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_EXCHANGES_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
                <v-col v-if="authData" cols="12" :sm="6" :md="4" class="pa-0 pl-sm-0 pr-sm-4 pr-md-4 pb-3 pb-sm-12 pb-md-12 pt-md-12">
                    <v-card fluid tile class="main-menu-navigation-card" elevation="0">
                        <router-link class="catalog-top-nav-router-link" :to="{name: 'servers-list', query: {'env': $config.query_params.env ? $config.query_params.env : 'SEVDEIR'} }">
                            <div class="main-menu-navigation-card-title">Шлюзи безпечного обміну <v-icon style="font-size: 18px; color: green">mdi-lock-open</v-icon></div>
                            <div class="main-menu-navigation-card-text d-none d-sm-block">{{ $config.translation.ua.MAIN_PAGE_SERVERS_DESCRIPTION }}</div>
                        </router-link>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</span>
</template>


<script>
/* eslint-disable */

import { mapState } from 'vuex';

export default {
  name: "CatalogMainPage",
  props: ['items_per_page', 'current_page', 'list_size'],
  data: () => ({
    auhenticated: false,
  }),
    created: function () {
        console.log("FFFFFFFF");
        console.log(this.authData);
    },
    computed: {
        ...mapState(['authData']),

        page_count: function() {
            if (this.list_size && this.items_per_page) {
                return Math.ceil(this.list_size / this.items_per_page);
            }
        },
        items_per_page_input: {
            get: function() {
                return this.items_per_page;
            },
            set: function(newValue) {
                this.$emit('update:items_per_page', newValue);
            }   
        },

        current_page_input: {
            get: function() {
                return this.current_page;
            },
            set: function(newValue) {
                this.$emit('update:current_page', newValue);
            }   
        },
    },

    watch: {
        current_page: {
            handler () {
                window.scrollTo(0, 0);
                this.$emit('on-update');
            },
        },

        items_per_page: {
            handler () {
                window.scrollTo(0, 0);
                if (this.current_page != 1)
                    this.$emit('update:current_page', 1);
                else
                    this.$emit('on-update');
            },
        }
    },

    methods: {
        paginationPrevPage() {
            if (this.current_page > 1)
                this.$emit('update:current_page', this.current_page - 1);
        },

        paginationNextPage() {
            if (this.current_page < this.page_count)
                this.$emit('update:current_page', this.current_page + 1);
        },
    }
}
</script>